import React, { ChangeEvent, forwardRef } from 'react';

export interface CheckMarkProps {
  name: string;
  // size?: 'sm' | 'lg';
  // fill?: 'fill' | 'outline';
  // type?: 'primary' | 'secondary' | 'danger' | 'warning' | 'success' | 'info';
  // shape?: 'square' | 'round';
  defaultChecked?: boolean;
  g;
  disabled?: boolean;
  value?: string;
  controlling?: boolean;
  checked?: boolean;
  label?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

// eslint-disable-next-line react/display-name
const CheckMark = forwardRef<HTMLInputElement, CheckMarkProps>(
  (
    {
      name,
      // type = 'primary',
      defaultChecked,
      // fill = 'outline',
      // size = 'lg',
      // shape = 'square',
      disabled,
      onChange,
      value,
      controlling,
      checked,
      label,
      ...props
    }: CheckMarkProps,
    ref,
  ) => {
    return (
      <>
        <label className="containers">
          {label && label}
          <input
            ref={ref}
            {...props}
            name={name}
            type="checkbox"
            disabled={disabled}
            value={value}
            {...(controlling && {
              onChange: onChange,
              checked: checked,
            })}
            {...(!controlling &&
              defaultChecked && {
                defaultChecked: defaultChecked,
              })}
          />
          <span className="checkmark"></span>
        </label>
      </>
    );
  },
);
export default CheckMark;
